var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"text-reader"},[_vm._v(" "+_vm._s(_vm.label)+" "),_c('input',{ref:"input",attrs:{"type":"file"},on:{"change":_vm.loadTextFromFile}})])
}
var staticRenderFns = []

export { render, staticRenderFns }